export const selectLeaveTypes = (state) =>
  state.companyapplyLeave.leaveTypes;

export const selectLeaveTypesLoading = (state) =>
  state.companyapplyLeave.leaveTypesLoading;

export const selectLeaveTypesError = (state) =>
  state.companyapplyLeave.leaveTypesError;

export const selectLeaveSummary = (state) =>
  state.companyapplyLeave.leaveSummary;

export const selectLeaveSummaryLoading = (state) =>
  state.companyapplyLeave.leaveSummaryLoading;

export const selectLeaveSummaryError = (state) =>
  state.companyapplyLeave.leaveSummaryError;

export const selectMyLeaves = (state) =>
  state.companyapplyLeave.myLeaves || [];

export const selectMyLeavesLoading = (state) =>
  state.companyapplyLeave.myLeavesLoading;

export const selectMyLeavesError = (state) =>
  state.companyapplyLeave.myLeavesError;

export const selectApplyLoading = (state) =>
  state.companyapplyLeave.applyLoading;

export const selectApplyError = (state) =>
  state.companyapplyLeave.applyError;

export const selectCancelLoading = (state) =>
  state.companyapplyLeave.cancelLoading;

export const selectCancelError = (state) =>
  state.companyapplyLeave.cancelError;

export const selectSelectedLeave = (state) =>
  state.companyapplyLeave.selectedLeave;